import { Platform } from 'react-native';
import * as amplitude from '@amplitude/unified';

const APP_ENV = process.env.EXPO_PUBLIC_APP_ENV ?? 'remote-dev';
const AMPLITUDE_API_KEY = process.env.EXPO_PUBLIC_AMPLITUDE_API_KEY ?? '';
let initialized = false;

export function initializeAnalytics(): void {
  if (Platform.OS !== 'web' || APP_ENV !== 'production' || !AMPLITUDE_API_KEY || initialized) return;

  initialized = true;
  amplitude.initAll(AMPLITUDE_API_KEY, {
    analytics: { autocapture: true },
    sessionReplay: { sampleRate: 1 },
  });
  amplitude.track('Opened App', {
    prompt_version: 'BA400.4',
    environment: 'production',
  });
}

export function trackAnalyticsEvent(
  eventName: string,
  properties: Record<string, string | number | boolean | null> = {},
): void {
  if (Platform.OS !== 'web' || APP_ENV !== 'production' || !AMPLITUDE_API_KEY) return;

  initializeAnalytics();
  amplitude.track(eventName, { ...properties, environment: 'production' });
}
